exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-az-tsx": () => import("./../../../src/pages/AZ.tsx" /* webpackChunkName: "component---src-pages-az-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-word-tsx": () => import("./../../../src/templates/word.tsx" /* webpackChunkName: "component---src-templates-word-tsx" */)
}

